<template>
  <div
    :id="popupId"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h2>RELAUNCH | PICKL Optimization Program</h2>
          <button
            ref="popupCloseButton"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
            <div class="row" style="border:1px solid #12db6d; padding: 2%;" v-if="step == 1">
                <h3 style="margin-left:1%;text-align:center;color:black;">How would you like to re-launch the tasks? </h3>
                </div>
            <div class="row">
                <br/>
                <button class="pull-right  btn-positive" :disabled="submittingForm" @click="relaunchSelectedPickls" v-html="relaunchButtonLabel"></button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PicklItem from '@/components/common/PicklItem.vue'
export default {
  props: ['popupId', 'picklIds'],
  components: {
    PicklItem
  },
  data: function () {
    return {
      selectAllStates: 0,
      step: 1,
      selectedPicklsList: [],
      hoverRating: 0,
      rating: 0,
      needReview: '',
      ShowNotesToBrand: 1,
      relaunchButtonLabel: 'RELUNCH',
      submittingForm: false
    }
  },
  mounted () {
    this.getStates()
  },
  methods: {
    toggleSelectedStates () {
      console.log(this.selectAllStates)
      if (this.selectAllStates) {
        this.selectedStates = []
        this.states.forEach((state) => {
          this.selectedStates.push(state.id)
        })
      } else {
        this.selectedStates = []
      }
    },
    isSelectedPickl (picklId) {
      if (this.selectedPicklsList.includes(picklId)) {
        return true
      } else {
        return false
      }
    },
    toggleSelectedPicklList (picklId) {
      if (this.selectedPicklsList.includes(picklId)) {
        this.selectedPicklsList.splice(this.selectedPicklsList.indexOf(picklId), 1)
      } else {
        this.selectedPicklsList.push(picklId)
      }
    },
    nextStep () {
      this.step = this.step + 1
    },
    backStep () {
      this.step = this.step - 1
    },
    relaunchSelectedPickls () {
      this.relaunchButtonLabel = 'Relaunching Now, Please wait...'
      this.submittingForm = true
      let payload = { picklIds: this.picklIds }
      console.log(payload)
      this.$store.dispatch('relaunchPickls', payload).then((response) => {
        console.log(response.body)
        this.relaunchButtonLabel = 'RELUNCH'
        this.submittingForm = false
        this.$emit('submitted')
        this.$notify({ type: 'success', text: response.body.message, duration: 3000 })
        this.$refs.popupCloseButton.click()
      })
    }
  }
}
</script>
<style scoped>
p {
  color: #232323;
  font-size: 24px;
  text-align: center;
}
.rate-picklr {
  cursor: pointer;
  margin-bottom: 45px;
}

.rate-picklr span {
  display: inline-block;
}

.rate-picklr img {
  width: 33px;
  height: 31px;
  margin: 0 8px;
}
table.user-pickl-table>tr {
  border: solid 1px gainsboro;
}
table.user-pickl-table>tr>td {
  padding: 5px 5px;
}

.bottom-margin {
    margin-bottom: 10px;
}
.pickl-selected {
  box-shadow: 0px 0px 10px 2px #12db6d;
}
.pickl {
    cursor: pointer;
}
</style>
